(function () {
  'use strict';

  var MQ = '(min-width: 992px)';

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function ProductScroll(section) {
    this.section = section;
    this.track = section.querySelector('[data-amr-scroll-track]');
    this.mediaQuery = window.matchMedia(MQ);
    this.ticking = false;
    this.enabled = false;
    this.setWidth = 0;
    this.lastX = null;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.onMediaChange);
    } else {
      this.mediaQuery.addListener(this.onMediaChange);
    }

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    window.addEventListener('load', this.onResize);

    this.onMediaChange();
  }

  ProductScroll.prototype.measure = function () {
    if (!this.track) {
      return;
    }

    var cards = this.track.querySelectorAll('[data-amr-scroll-card]');
    var half = Math.floor(cards.length / 2);

    if (half < 1) {
      this.setWidth = 0;
      return;
    }

    var first = cards[0];
    var nextSet = cards[half];

    if (first && nextSet) {
      this.setWidth = nextSet.offsetLeft - first.offsetLeft;
    } else {
      this.setWidth = this.track.scrollWidth / 2;
    }
  };

  ProductScroll.prototype.enable = function () {
    if (this.enabled || !this.track) {
      return;
    }

    this.enabled = true;
    this.lastX = null;
    this.section.classList.add('amr-scroll-products--ready');
    this.track.style.willChange = 'transform';
    this.measure();
    this.update(true);

    var self = this;
    setTimeout(function () {
      self.measure();
      self.update(true);
    }, 300);
  };

  ProductScroll.prototype.disable = function () {
    if (!this.enabled) {
      return;
    }

    this.enabled = false;
    this.lastX = null;
    this.section.classList.remove('amr-scroll-products--ready');
    this.track.removeAttribute('style');
  };

  ProductScroll.prototype.getTranslateX = function () {
    var setWidth = this.setWidth;

    if (!setWidth) {
      return 0;
    }

    var rect = this.section.getBoundingClientRect();
    var vh = window.innerHeight;

    /* Section below viewport */
    if (rect.top >= vh) {
      return 0;
    }

    /* Section above viewport */
    if (rect.bottom <= 0) {
      return -setWidth;
    }

    /*
     * Linear map for entire time section is visible.
     * Each scroll down increases progress → products move left-to-right.
     */
    var scrollStart = vh;
    var scrollEnd = -rect.height;
    var scrollRange = scrollStart - scrollEnd;
    var progress = clamp((scrollStart - rect.top) / scrollRange, 0, 1);

    return -progress * setWidth;
  };

  ProductScroll.prototype.update = function (force) {
    if (!this.enabled) {
      return;
    }

    var x = this.getTranslateX();

    if (!force && x === this.lastX) {
      return;
    }

    this.lastX = x;
    this.track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
  };

  ProductScroll.prototype.onScroll = function () {
    if (!this.enabled) {
      return;
    }

    if (!this.ticking) {
      this.ticking = true;
      var self = this;

      window.requestAnimationFrame(function () {
        self.ticking = false;
        self.update();
      });
    }
  };

  ProductScroll.prototype.onResize = function () {
    if (!this.enabled) {
      return;
    }

    this.lastX = null;
    this.measure();
    this.update(true);
  };

  ProductScroll.prototype.onMediaChange = function () {
    if (this.mediaQuery.matches) {
      this.enable();
    } else {
      this.disable();
    }
  };

  function init() {
    if (!document.body.classList.contains('template-index')) {
      return;
    }

    document.querySelectorAll('[data-amr-scroll-products]').forEach(function (section) {
      new ProductScroll(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-amr-scroll-products]');

    if (section) {
      new ProductScroll(section);
    }
  });
})();
